import { MeasureType } from "../../contexts/OrderContext";

export type MethodsPaymentType =
  | "delivery-payment"
  | "totvs-card"
  | "esitef-card"
  | "cielo-card"
  | "pagseguro-card"
  | "pagseguro-pix"
  | "rede-card"
  | `${string}-wallet`

type BrandType =
  | "visa"
  | "mastercard"
  | "americanexpress"
  | "elo"
  | "hipercard"
  | "maestro"
  | "rede"
  | "ticket"
  | "alelo"
  | "others";


type PluginconfigType = {
  id: number;
  pluginspaceId: number;
  plugintypeId: number;
  plugintemplateId: {
    id: number;
    name: string;
  };
  name: string;
  content: any;
};

type AddressLocationType = {
  cep: string;
  city: string;
  district: string;
  extra: string;
  number: string;
  state: string;
  street: string;
};

type LocationResponseType = {
  address: AddressLocationType;
  type: string;
  name: string;
  code: string;
};

type ProcessorWalletType = {
  externalCode: string;
  processorId: string;
};

type WalletType = {
  id: string;
  code: string;
  logo: string;
  name: string;
  processorDigitalWallets: ProcessorWalletType[];
};

type ProductCartType = {
  id: number;
  img: string;
  sku: string;
  variation: any;
  name: string;
  price: number;
  unitPrice: number;
  discount: number;
  discountGeral: number;
  promotional_price: number;
  quantity: number;
  code: string;
  sku_info: Array<{
    vendas: number;
    inventory: number;
    minimum_stock: number;
    measures?: MeasureType;
  }>;
};

type PlansType = {
  id: number;
  codePlan: number;
  installment: number;
};

type IntegrationType = {
  id: number;
  pluginconfigId: number;
  brand: BrandType;
  cardOperator: number;
  codePay: string;
  nameGateway: string;
  paymentPlans: PlansType[];
  typePay: string;
  plugintemplateId: number;
  ableDiscount: boolean;
  discountValue: string;
  typeDiscount: 'monetary' | 'percentage' | undefined;
  installment?: number;
  installmentValue?: number;
};


const CARD_OPERATORS = {
  MONEY: 100,
  PIX: 99,
  SODEX: 23,
  VR: 26,
  ALELO: 10,
  TICKET: 27,
};

const FOOD_OPERATORS = new Set([
  CARD_OPERATORS.SODEX,
  CARD_OPERATORS.VR,
  CARD_OPERATORS.ALELO,
  CARD_OPERATORS.TICKET,
]);

const EXCLUDED_CARD_OPERATORS = new Set([
  CARD_OPERATORS.MONEY,
  CARD_OPERATORS.PIX,
  CARD_OPERATORS.SODEX,
  CARD_OPERATORS.VR,
  CARD_OPERATORS.ALELO,
  CARD_OPERATORS.TICKET,
]);

export { CARD_OPERATORS, FOOD_OPERATORS, EXCLUDED_CARD_OPERATORS };

export type { PluginconfigType, LocationResponseType, WalletType, ProductCartType, IntegrationType, PlansType };